import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollProgress } from './components/ScrollProgress';
import { Home } from './pages/Home';
import { Accommodations } from './pages/Accommodations';
import { Experiences } from './pages/Experiences';
import { Gallery } from './pages/Gallery';
import { BookingPage } from './pages/BookingPage';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
function AnimatedRoutes() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [location.pathname]);
  return <AnimatePresence mode="wait" initial={false} data-id="element-0" data-mp="28u5zkrcq1dey">
      <motion.div key={location.pathname} initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-1" data-mp="28suveqfd63nb">
        <Routes location={location} data-id="element-2" data-mp="3ii4ppvcl6gle">
          <Route path="/" element={<Home data-id="element-4" data-mp="3mjzrt22ccy08" />} data-id="element-3" data-mp="3mkrgdsxitvh0" />
          <Route path="/accommodations" element={<Accommodations data-id="element-6" data-mp="3rbrbcsn2y3gv" />} data-id="element-5" data-mp="3mjg93j4va5l5" />
          <Route path="/experiences" element={<Experiences data-id="element-8" data-mp="3relvej26lm9r" />} data-id="element-7" data-mp="3rdkl4gszp3t3" />
          <Route path="/gallery" element={<Gallery data-id="element-10" data-mp="4n6o4eeqtbm" />} data-id="element-9" data-mp="6hp9c27i9cj" />
          <Route path="/booking" element={<BookingPage data-id="element-12" data-mp="2zld2xbxu5jcl" />} data-id="element-11" data-mp="82kz509bybz" />
          <Route path="/about" element={<About data-id="element-14" data-mp="2zmwguvw0rib7" />} data-id="element-13" data-mp="2zm4wkh7vh708" />
          <Route path="/contact" element={<Contact data-id="element-16" data-mp="33lwxq8uxsavk" />} data-id="element-15" data-mp="2znfyebhrc4op" />
          <Route path="*" element={<Home data-id="element-18" data-mp="33orhrza1ftog" />} data-id="element-17" data-mp="33ngfk3w8qtzg" />
        </Routes>
      </motion.div>
    </AnimatePresence>;
}
export function App() {
  return <BrowserRouter data-id="element-19" data-mp="3dkuuu06fhcq6">
      <ScrollProgress data-id="element-20" data-mp="3dle28mygcipy" />
      <div className="flex min-h-screen w-full flex-col bg-ivory-100" data-id="element-21" data-mp="3dlwa6guh8ldp">
        <Header data-id="element-22" data-mp="nw2bc3tnpmq1" />
        <main className="flex-1" data-id="element-23" data-mp="nuhg0bzipzr4">
          <AnimatedRoutes data-id="element-24" data-mp="nvaszup2llhp" />
        </main>
        <Footer data-id="element-25" data-mp="sudoanf90dch" />
      </div>
    </BrowserRouter>;
}